export default __webpack_public_path__ + "static/media/category_image_2.2ca1db8f.webp";